module.exports = __webpack_public_path__ + "static/media/lac.4b66e5b2.png";